import { useState } from 'react'

import { useLocalizedRouter } from '@src/hooks/useLocalizedRouter'
import {
  getDefaultLocale,
  getLocaleForCountryCodeLang,
  getUnlocalizedPath,
} from '@src/i18n/locale.util'
import { COOKIES } from '@src/utils/constants.util'
import { setBrowserCookie } from '@src/utils/cookies.util'

const setCookie = async () => {
  // set a session cookie
  setBrowserCookie(COOKIES.geoRedirectionModal, 'true', 'path=/')
}

const getRedirectUrl = (selectedCountryCode: string) => {
  const url = new URL(window.location.href)
  const unlocalizedPath = getUnlocalizedPath(url.pathname)

  const userLang = window.navigator.language ?? getDefaultLocale().lang
  const selectedLocale = getLocaleForCountryCodeLang(selectedCountryCode?.toLowerCase(), userLang)

  const redirectPathname = `${selectedLocale?.path}${unlocalizedPath}`

  url.pathname = redirectPathname

  return url.toString()
}

export const useGeoRedirectionModalHandlers = ({
  selectedCountryCode,
  onClose,
}: {
  selectedCountryCode: string | undefined
  onClose: () => void
}) => {
  const router = useLocalizedRouter()
  const [isLoading, setIsLoading] = useState(false)

  const onConfirm = () => {
    setCookie()

    if (!selectedCountryCode) {
      onClose()
      return
    }

    const redirectUrl = getRedirectUrl(selectedCountryCode)
    if (!redirectUrl) {
      onClose()
      return
    }

    setIsLoading(true)
    router.push(redirectUrl, { hard: true })
  }

  const onCancel = () => {
    onClose()
    setCookie()
  }

  return { onConfirm, onCancel, isLoading }
}
